import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth11: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M9.7,42.9l14.1-9,17.4-3.1s22.7.4,23.4.4,18.1,1.8,18.1,1.8l18.5.4,10.1.2,7.9.4,4.4,2.2,2.9,3.1,1.8,4.6.2,7.3v6.2l-.4,7.9-1.5,7.7-3.1,17.2-2.4,13.4-.7,10.4-2.2,11.2-2.4,12.8-7.3,19.2-2.2,4.6-2.9,7.3-3.3,7.3-4.4,5.7-9,8.4-9.9,3.1-6.2.9-3.5-1.8-2.4,1.5-5.1,1.5-9.5-.7-6.2-1.5-6.4-2.9-4.8-4-5.5-6.2-4.2-7.5-3.3-4.4-.4-7.3-5.3-11.2-4.6-19.2-3.1-18.5-4-33.9-.7-14.3,8.2-21.4Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M80.7,107.4a16.1,16.1 0 1,1 -32.2,0a16.1,16.1 0 1,1 32.2,0',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.6,141.2l3.4-13.1,2.3-18.1,2-13.4s-54.8,12.4-7.7,44.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.4,97.6l1.2,13.4,2.4,18.2,3.7,12.5s47.3-27.6-7.2-44.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '3.3 59.5 128.8 59.5 128.8 45.7 127.4 41.3 125.1 37.5 121.5 35.5 109.9 33.4 66.3 31.5 39.8 31.5 30.8 33.2 25.6 34.3 9.7 43.4 3.3 59.5',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M83.6,33.8l27,.4,7.9.9,5.5,1.7,3.4,6.1,1.3,9.1-.6,8.9-1.7,13.8-3.4,18.5-2.3,12.5-1.3,11-1.5,12.5-4.7,16.3-3.6,6.8-2.3,7.4-7.1,15.1-6.1,9.7s-12.3-32.1-10.7-150.6Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M2.9,60.5l6.7-16.9,15.8-8.9,14.2-2.7h8.2s8.4,131.3-11.1,156.9l-5-3.8-4.4-5.3-3-5.4-3.1-6-.9-1.5-5.8-17.1-3.5-11.9-2.4-7.8-1.4-11.3-1.5-13.2-1.6-13.3-1.4-14.8.2-11.8v-5.3Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20,165.9l3.3,6.5,4.8,8.6,3.3,3.8,5.7,4.9,6.1,2.5,9.4,2.7s7.9.1,8.2.1h9.1l7.3-.5,6.5-2.4,7.1-4.8,4.8-5,3.5-4.8,3.5-6.7,2.8-5.3,3.7-9.2-1.6,18.2-3.4,6.7-5.6,6.6-6,5.8-7.3,3.9-8.6,2.1-7.8.4h-10.1l-8.4-.6-8.7-3-7.2-2.5-6.5-5.2-5.3-6.4-1.3-2.6-1.3-14Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '2.9 59 9.5 42.9 24.9 34.4 41.1 31.2 66.9 31.5 116.4 34.3 123.6 35.9 126.3 38.7 128.2 43.8 128.4 60.9 126.7 74.8 123.5 91.3 120.1 107.3 118.6 121.4 117.4 130.8 114.7 140.8 111.4 148.8 108.8 156 104.2 167.4 100.6 174.6 95.1 182.5 92.1 187.5 84.8 191.7 77.2 194.2 63.7 195.8 58 195.9 44.9 193.6 36.3 189.5 29.8 182.4 24 174.5 20.3 167.9 20.2 163.3 13.9 148.2 10.1 134.5 6.8 116.3 5.4 101.5 2 78 1.9 64.9 2.9 59',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'8 93 19.8 111 25.7 85.9 33.5 116.5 43.7 85.1 53.2 116.5 63.8 85.5 73.6 116.5 84.2 83.5 92.8 114.9 104.2 83.5 107.7 109.8 122.2 93.7',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'72 197.1 61.8 203.3 73.5 210.6 63 216.9 73.9 223.6 64 229.5 73.7 235.6 64 241.3 75.2 248.2 65.8 253.8 74.7 259.3 65.3 264.9 75 271 65.1 276.9 74.4 282.6 64.3 288.5 72.9 293.8 63.1 299.7 73.5 306.1 62.1 312.9 72.2 319.1 61 325.8 71.2 332.3 60.1 338.9 72 346.2 61.8 352.3 72.7 359.1 60.6 366.2 72 377.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'36.7 270.3 40.5 280.5 44.8 269.7 49.4 279.5 54.8 270.6 61.4 281.1 67.3 268.4 74.4 280.5 81.4 268.4 87.4 279.5 93.4 268.7',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '27.9 73.9 41.1 67.7 52 65 64.5 62.1 72.5 61.4 82.1 61.2 95.1 62.8 106.9 70.8 123.8 96.1 124.8 102.6 121.9 107.7 114.9 113.9 107.2 123.8 100.4 132.3 93.2 141.2 87.6 144.6 79.2 148.7 72.9 150.3 65.7 150.8 58.2 149.9 47.2 144.1 40.7 138.8 32.7 130.3 24.7 123.3 17.5 117.1 7.9 113 3.5 109.4 .9 105 .9 97.8 6.9 89.6 16.1 81.9 27.9 73.9',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39,82.9l53.5-.5s-26.8-12.7-53.5.5Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '12.8 85.8 117.5 85.8 121 91.1 123 94.8 124 97.5 124.3 102.8 123.5 106 119.8 110.4 116.4 113.4 114.6 114.9 12.3 114.9 8.7 112.4 6.1 111.3 3.1 108.4 2.2 105.8 1.6 104.8 1.5 98.6 2.9 93.6 8 89.1 12.8 85.8',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.5,85.8l5.5,9.1.9,2.7.3,5.3-.8,3.2-3.8,4.4-5.2,4.4s-47.8-15.5,2.9-29.1Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12.3,114.9l-3.6-2.4-2.6-1.2-3-2.9-.9-2.6-.6-1v-6.2c-.1,0,1.3-5,1.3-5l5-4.5,4.9-3.3s45.2,13.9-.5,29.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M1.5,104.1v-6.3c0,0,3.4-5.9,3.4-5.9l4.6-3.8,10.4-8.2,12.7-8.6,11.1-4.4,9.5-2.6,10.9-2.1,5.2-.6h17.4l7,1.2,3.6.9,6.4,4.4,5.3,4.9,4.4,5.6,4.4,6.5,4.2,6.4,1.9,4.2.6,1.8v5c0,0-62.7-9.3-122.9,1.6Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.5,102.5l-1.1,4.2-4.3,4.2-4.8,4-6.8,9.1-8.2,9.9-3.8,4.2-4.5,3.8-6.1,3.7-3.7,2-4,1.2-4.9,1h-1.7c0,0-7.7.4-7.7.4l-6.8-1.5-6.8-3.3-6.7-4.9-5.1-4.7-5-4.7-4.8-4.9-5.1-5.1-5-4-4.8-1.4-4.5-3.1-4.1-2.4-2.3-3.1-1.1-3.2s49.2-11,123-1.6Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'3.4 95.4 15.8 111.3 22 89.2 30.3 116.2 41 88.5 51.1 116.2 62.2 88.8 72.6 116.2 83.7 87.1 92.9 114.8 104.8 87.1 108.5 110.3 123.9 96.1',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.3,355.8l8.4-12.7,7-4.7,10.4-7.9,14.6-4.7,18.4-2.7,12.2,2.2,7,2.2,7,7.7s5.7,6.5,6,7.2,3.5,10.2,3.5,10.2l11.7,51.6,5.2,44.2v23.1l-3.2,7.2-3.2,3s-5.5,2-6.2,2.2-13.9,1.5-13.9,1.5l-18.9,1s-11.7,1.5-12.4,1.5-17.9,1.5-17.9,1.5l-11.7,1s-13.4-1.7-14.9-2-18.1-7.9-18.1-7.9l-8.4-14.9-.7-19.9,2.7-22.1,2.7-24.6,4.5-20.6,3-10.9,5.5-11.7Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.7,388.3h52.5s-24.4-113.1-52.5,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129,442.1s-68.7-13.4-5.1-45.3',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M6.7,400.1s64.6,26.9-4.1,45.4',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '2.3 460 130.7 460 130.8 469.9 129.5 473.9 128.4 476.8 126.1 479.8 123.5 481.3 120.3 482.8 73.2 486.5 50.8 489.4 36.1 489.4 28 488.4 11.9 479.8 2.2 463.6 2.3 460',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.7,356.5l6.1-11.1,7.3-5.9,10-6.8,7.2-3.6,6.9-2.5,8.1-2.2,5.7-.2,7.6-.5s5.8.3,6.2.3,9.2,2.1,9.2,2.1l3.1,1.9,3.9,3.7,2.6,2.7,2.8,4.3,1.4,2.2,2.1,4,1.8,4.1,2.1,6-.4-7.2-.5-8.5-.8-4.6-3.8-6-3.2-3-5.5-3-3.9-1.3-5.4-1.4-6.6-1.1h-10c0,0-4,.2-4,.2l-5,.4-7.7,1.2-5.9,2-6.1,1.9-6,2.9-5,2.9-5,3.9-5.3,4.7-2.6,3.1-1.2,2.2-.2,12Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M85.6,485.5s-15.1-112,27.4-135.1l4,18.3,3.8,15.8,3,15.3,2.5,15.8,1,13.1,2.3,14.3.8,8.8s0,17.8-.3,18.8-1,4.5-1,4.5l-2.3,3.8-4.5,2.8-6.3,1.8-30.4,2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M50.4,490s4.3-121.5-31.1-131.8l-5.5,14.1-4,12.6-2.8,10-2,14.8-1,12.8-1.8,13.3-.3,13.1-.3,11.5.5,4.3,8.3,14.3,16.6,9.5,14.1,1.8,9.3-.3Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '19.6 356.7 26.3 345.5 32.1 340.2 34.8 339.4 45.1 332.3 49.8 329.5 62.7 325.4 73.3 324.8 81.4 324.5 88.3 325.7 94.6 326.9 99.5 330.4 103.3 333.7 105.8 337.1 108.5 341.4 110.8 345.8 112.8 350.5 113.9 353.1 115 359.2 118.2 372.3 121.9 389.2 124.8 405.4 127.7 426.3 130 445.3 130.5 451.4 130.3 470.9 129.3 475 126.9 478.6 123.5 481.3 121.7 482.1 112.6 483.9 76.3 486.6 52.2 489 41.2 489.6 28.4 488.3 11.7 479.6 2.9 465.6 1.4 444.2 4.7 413 6.3 396.1 10.8 378.1 14.8 367.5 19.6 356.7',
			},
			[ToothSurface.BuccalRestoration]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.2,357.6l6.4-11.4,4.7-4.7,8.3-5.9,6.2-4,7.8-4,7.2-2s5.8-1,6-1,5.4-.5,5.4-.5h7c0,0,4.3,0,4.3,0l7.3,1.3,5.2,1.5,2.1,1.5,4.6,3.9,3.8,4.2,2.7,4.4,2.6,4.9,1.8,5,1.8,5.6c-24.3,5.2-28.4,97.3-28.4,97.3l-33.3.2s-4.7-79.9-33.6-96.5Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'124.3 422.2 109.3 405.5 105.7 432.8 93.9 400.3 85 432.8 74 398.6 63.9 430.7 52.9 398.6 43.1 431.1 32.5 398.6 24.4 430.3 18.3 404.3 6.1 422.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'73.5 120.2 61.9 133.3 74.3 141.3 63.1 148.9 73.6 155.8 61.4 164 72.7 171.4 62.2 178.5 73.8 186 63.4 193 75.1 200.6 64.5 207.8 74.5 214.4 65.7 220.3 76 226.9 66.5 233.3 76.7 239.9 66.7 246.7 76.4 253 67.2 259.1 76.9 265.4 65.3 273.1 75.3 279.5 65.3 286.3 75.5 292.9 64.3 300.4 75.1 307.5 63.1 315.7 73.6 322.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'100 247.8 93.3 235.8 86.7 248.1 78.9 234.7 70.9 248.1 64.3 234 57 245.8 50.9 235.8 45.8 246.7 40.9 234.7 36.8 246.1',
			],
		},
	},
};
